import React, { useEffect, useState } from "react";
import { Box, Paper, Typography, Grid, Step, StepLabel } from "@mui/material";
import {
  CustomStepper,
  CustomConnector,
  CustomStepIcon,
} from "../../../components/layouts/common/Stepper";
import moment from "moment";
import { ORDER_PROCESS_STATUS, USER_ROLES } from "../../../utils/constants";
import CustomDialog from "../../../components/layouts/common/CustomDialog";
import { useSelector } from "react-redux";

const OrderViewController = ({ id, params }) => {
  const { user } = useSelector((state) => state);

  const orderStatus = params?.order_status;

  // const activeStep = stepMap[params?.order_status] ?? -1;
  const stepMap = {
    [ORDER_PROCESS_STATUS?.ORDER_RECEIVED]: 0,
    [ORDER_PROCESS_STATUS?.ORDER_ACCEPTED]: 1,
    [ORDER_PROCESS_STATUS?.ORDER_SHIPPED]: 2,
    [ORDER_PROCESS_STATUS?.FULFILLED]: 3,
  };

  const baseSteps = [ 
    user?.data?.role === USER_ROLES?.DISTRIBUTOR ? "Order Placed" : "Order Received",
    "Order Accepted",
    "Order Shipped",
    "Fulfilled",
  ];
  // let steps = [...baseSteps];
  // let activeStep = -1;
  const [animatedStep, setAnimatedStep] = useState(0);
  const [maxVisibleStep, setMaxVisibleStep] = useState(0);
  const [isAnimationComplete, setIsAnimationComplete] = useState(false);
  
  let steps = [...baseSteps];
  let activeStep = -1;
  let isRejected = false;

  if (orderStatus === ORDER_PROCESS_STATUS?.ORDER_REJECTED) {
    if(params?.isAssigned === true){
      steps.splice(2, 0, "Order Rejected");
      activeStep = 2;
    }else{
    steps.splice(1, 0, "Order Rejected");
    activeStep = 1;
    }
  } else {
    activeStep = stepMap[orderStatus] ?? -1;
  }

   useEffect(() => {
    // Start the animation once the component is mounted
    if (!isAnimationComplete) {
      let currentStep = 0;
      
      // Create a sequence that reveals each step one by one
      const interval = setInterval(() => {
        if (currentStep <= activeStep) {
          setAnimatedStep(currentStep);
          setMaxVisibleStep(currentStep);
          currentStep++;
        } else {
          clearInterval(interval);
          setIsAnimationComplete(true);
        }
      }, 450); // 2-second interval between steps
      
      return () => clearInterval(interval);
    }
  }, [activeStep, isAnimationComplete]);

  const rootStyle = {
    "--step-opacity-2": maxVisibleStep >= 1 ? "1" : "0.5",
    "--step-transform-2": maxVisibleStep >= 1 ? "0" : "0px",
    "--step-opacity-3": maxVisibleStep >= 2 ? "1" : "0.5",
    "--step-transform-3": maxVisibleStep >= 2 ? "0" : "0px",
    "--step-opacity-4": maxVisibleStep >= 3 ? "1" : "0.5",
    "--step-transform-4": maxVisibleStep >= 3 ? "0" : "0px",
    "--step-opacity-5": maxVisibleStep >= 4 ? "1" : "0.5",
    "--step-transform-5": maxVisibleStep >= 4 ? "0" : "0px",
  };

  return (
    <CustomDialog id={"OrderInformation"} title={"Order Details"}>
      <Box>
        <Paper
          elevation={0}
          sx={{ width: "100%", minHeight: "100%", padding: 3 }}
        >
          <Box
            p={2}
            sx={{
              border: "1px solid #1B4381",
              borderRadius: "5px",
              backgroundColor: "white",
            }}
          >
            <Box mb={2}>
              <Typography variant="h6" gutterBottom>
                Order No : {params?.order_id}
              </Typography>
              <Typography variant="body1">
                Order Date :{" "}
                {params?.createdAt
                  ? moment(params?.createdAt).format("DD/MM/YYYY")
                  : "NA"}
              </Typography>
            </Box>

            {/* <CustomStepper
              alternativeLabel
              activeStep={activeStep}
              connector={<CustomConnector />}
            >
              {steps.map((label, index) => (
                <Step key={index}>
                  <StepLabel
                    StepIconComponent={(props) => (
                      <CustomStepIcon
                        {...props}
                        label={label}
                        completed={index <= activeStep}
                        index={index}
                        activeStep={activeStep}
                        isLastStep={index === steps.length - 1}
                      />
                    )}
                  >
                    {label}
                  </StepLabel>
                </Step>
              ))}
            </CustomStepper> */}
            <Box style={rootStyle}>
              <CustomStepper
                alternativeLabel
                activeStep={animatedStep}
                connector={
                  <CustomConnector className={isRejected ? "connector-rejected" : ""} />
                }
              >
                {steps.map((label, index) => (
                  <Step key={index}>
                    <StepLabel
                      StepIconComponent={(props) => (
                        <CustomStepIcon
                          {...props}
                          label={label}
                          completed={index <= animatedStep}
                          index={index}
                          activeStep={animatedStep}
                          isLastStep={index === steps.length - 1}
                        />
                      )}
                    >
                      {label}
                    </StepLabel>
                  </Step>
                ))}
              </CustomStepper>
            </Box>
          </Box>

          <Box mt={4} sx={{ border: "1px solid #1B4381", borderRadius: "5px" }}>
            {(orderStatus === ORDER_PROCESS_STATUS?.ORDER_REJECTED) && (
              <>
              <Grid container sx={{ p: 2, mt: 1 }}>
                <Grid item xs={4}>
                  <Typography variant="body1">Reason of Order Cancellation :</Typography>
                </Grid>
                <Grid item xs={8}>
                  <Typography variant="body1">
                    {params?.reason ?? "NA"}
                  </Typography>
                </Grid>
              </Grid>
              </>
            )}
            
            
            <Grid container sx={{ p: 2 }}>
              <Grid item xs={4}>
                <Typography variant="body1">Box Id :</Typography>
              </Grid>
              <Grid item xs={8}>
                <Typography variant="body1">
                  {params?.box_id ?? "NA"}
                </Typography>
              </Grid>
            </Grid>

            <Grid container sx={{ p: 2 }}>
              <Grid item xs={4}>
                <Typography variant="body1">Customer Name :</Typography>
              </Grid>
              <Grid item xs={8}>
                <Typography variant="body1">{params?.name ?? "NA"} </Typography>
              </Grid>
            </Grid>

            <Grid container sx={{ p: 2 }}>
              <Grid item xs={4}>
                <Typography variant="body1">Product :</Typography>
              </Grid>
              <Grid item xs={8}>
                <Typography variant="body1">
                  {params?.product ?? "NA"}
                </Typography>
              </Grid>
            </Grid>

            <Grid container sx={{ p: 2 }}>
              <Grid item xs={4}>
                <Typography variant="body1">Shipping Date :</Typography>
              </Grid>
              <Grid item xs={8}>
                <Typography variant="body1">
                  {params?.shipping_date
                    ? moment(params?.shipping_date).format("DD/MM/YYYY")
                    : "NA"}
                </Typography>
              </Grid>
            </Grid>
              
            {user?.data?.role !== USER_ROLES?.DISTRIBUTOR && (
              <>
              <Grid container sx={{ p: 2 }}>
                <Grid item xs={4}>
                  <Typography variant="body1">Order From :</Typography>
                </Grid>
                <Grid item xs={8}>
                  <Typography variant="body1">
                    {params?.distributor_name ?? "NA"}
                  </Typography>
                </Grid>
              </Grid>
              </>
            )}

            <Grid container sx={{ p: 2 }}>
              <Grid item xs={4}>
                <Typography variant="body1">Courier Name :</Typography>
              </Grid>
              <Grid item xs={8}>
                <Typography variant="body1">
                  {params?.courier_name ?? "NA"}
                </Typography>
              </Grid>
            </Grid>

            <Grid container sx={{ p: 2 }}>
              <Grid item xs={4}>
                <Typography variant="body1">Tracking Id :</Typography>
              </Grid>
              <Grid item xs={8}>
                <Typography variant="body1">
                  {params?.tracking_id ?? "NA"}
                </Typography>
              </Grid>
            </Grid>

            <Grid container sx={{ p: 2 }}>
              <Grid item xs={4}>
                <Typography variant="body1">Tracking Link :</Typography>
              </Grid>
              <Grid item xs={8}>
                <Typography sx={{ wordBreak: "break-word" }}>
                  {params?.tracking_link ? (
                    <a
                      href={params?.tracking_link}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{
                        color: "#1B4381",
                        textDecoration: "none",
                        fontWeight: "bold",
                      }}
                    >
                      {params?.tracking_link}
                    </a>
                  ) : (
                    "NA"
                  )}
                </Typography>
              </Grid>
            </Grid>
          </Box>
        </Paper>
      </Box>
    </CustomDialog>
  );
};

export default OrderViewController;
